import * as Yup from 'yup';

const ForgetPasswordSchema = Yup.object().shape({
  email: Yup.string().email('invalidEmail').required('required.email'),
});

export default ForgetPasswordSchema;
